import * as tslib_1 from "tslib";
import CategoryIconBar from './CategoryIconBar';
import CategoryTextField from './CategoryTextField';
import { addCategory, updateExistingCategoryColor } from '../actions/addOrUpdateCategory';
import clearNewCategoryState from '../actions/clearNewCategoryState';
import setCategoryColorOnNewCategory from '../actions/setCategoryColorOnNewCategory';
import datapoints from '../datapoints';
import store from '../store/store';
import { observer } from 'mobx-react';
import { logUsage } from 'owa-analytics';
import { CategoryColorPickerHost, getStore as getCategoryStore, isCategoryNameValid, } from 'owa-categories';
import * as React from 'react';
var styles = require('./CategoryRow.scss');
export var NEW_CATEGORY_COLOR_PICKER_SOURCE = 'newCategoryColorPickerSource';
var CategoryRow = /** @class */ (function (_super) {
    tslib_1.__extends(CategoryRow, _super);
    function CategoryRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isNewCategoryPending = function () {
            // Favorite icon is disabled for pending newly created categories, because we don't have the server category id to favorite it
            return !!getCategoryStore().pendingNewCategoriesNameMap[_this.props.name];
        };
        _this.trySaveNewCategory = function (createTrigger) {
            // Add category if valid
            // and always clear the store state after adding a new category
            if (isCategoryNameValid(store.newCategory.Name)) {
                addCategory(_this.props.id, store.newCategory.Name, store.newCategory.Color);
                logUsage(datapoints.categoryOptionsyNewCategoryCreate.datapoint.name, datapoints.categoryOptionsyNewCategoryCreate.datapoint.customData(createTrigger));
                clearNewCategoryState();
                return true;
            }
            return false;
        };
        _this.onBlurOnTextField = function (evt) {
            evt.preventDefault();
            var relatedTargetElement = evt.relatedTarget;
            var clickSourceProperty = 'clickSource';
            var isBlurSourceFromCategoryColorPicker = relatedTargetElement
                ? relatedTargetElement.dataset[clickSourceProperty] == NEW_CATEGORY_COLOR_PICKER_SOURCE
                : false;
            // If the focus was not on the new category color picker then
            // try committing new category, but always dismiss the new category state
            if (!isBlurSourceFromCategoryColorPicker) {
                _this.trySaveNewCategory(1 /* OnBlurOnTextField */);
                clearNewCategoryState();
            }
        };
        // Called when color picker losses focus
        _this.onBlurOnColorPicker = function () {
            // If this was a new category row then
            // try committing the category
            // if the row fails to commit then focus on the text field
            if (_this.props.isNewCategoryRow) {
                if (!_this.trySaveNewCategory(2 /* OnBlurOnColorPicker */)) {
                    _this.focusTextField();
                }
            }
        };
        // Called when a color is selected for a new category
        _this.updateCategoryColorOnNewCategory = function (categoryColor) {
            setCategoryColorOnNewCategory(categoryColor);
            _this.trySaveNewCategory(3 /* OnSelectColor */);
            _this.focusTextField();
        };
        // Called when a color is selected for an existing category
        _this.updateCategoryColorOnExistingCategory = function (categoryColor) {
            updateExistingCategoryColor(_this.props.id, categoryColor);
        };
        _this.focusTextField = function () {
            if (_this.textFieldRef) {
                _this.textFieldRef.focus();
            }
        };
        return _this;
    }
    CategoryRow.prototype.render = function () {
        var _this = this;
        var categoryContainer = this.props.isNewCategoryRow
            ? styles.newCategoryRowContainer
            : styles.existingCategoryRowContainer;
        var onNewCategoryColorSelected = this.props.isNewCategoryRow
            ? this.updateCategoryColorOnNewCategory
            : this.updateCategoryColorOnExistingCategory;
        return (React.createElement("div", { className: categoryContainer },
            React.createElement(CategoryColorPickerHost, { colorPickerIconContainerClass: styles.colorPickerIconContainer, categoryColorId: this.props.colorId, categoryColorPickerSource: this.props.isNewCategoryRow ? NEW_CATEGORY_COLOR_PICKER_SOURCE : null, onBlur: this.onBlurOnColorPicker, onNewCategoryColorSelected: onNewCategoryColorSelected }),
            this.props.isNewCategoryRow ? (React.createElement(CategoryTextField, { ref: function (ref) {
                    _this.textFieldRef = ref;
                }, key: "categoryTextField", id: this.props.id, trySaveNewCategory: this.trySaveNewCategory, onBlurOnTextField: this.onBlurOnTextField })) : (React.createElement("div", { className: styles.categoryRowContent },
                React.createElement("div", { className: styles.categoryRowContent, title: this.props.name }, this.props.name),
                React.createElement(CategoryIconBar, { key: this.props.id, id: this.props.id, name: this.props.name, isNewCategoryPending: this.isNewCategoryPending() })))));
    };
    CategoryRow = tslib_1.__decorate([
        observer
    ], CategoryRow);
    return CategoryRow;
}(React.Component));
export default CategoryRow;
//# sourceMappingURL=CategoryRow.js.map